import React from 'react';
import Button from 'Components/Button';
import InternetExplorerIcon from 'Assets/img/internet-explorer.svg';
import ChromeIcon from 'Assets/img/icon-chrome.svg';
import MSEdgeIcon from 'Assets/img/icon-microsoft-edge.svg';

import './NoSupportIE11.scss';

const NoSupportIE11 = () => {
    const lang = localStorage.getItem('language') || 'en-US';

    const IE11Trans = {
        title: {
            'en-US': 'Internet Explorer is no longer supported',
            'fr-CA': 'Internet Explorer n’est plus compatible',
            'zh-Hans': '不再支援 Internet Explorer',
            'zh-Hant': '不再支援 Internet Explorer',
        },
        description: {
            'en-US': 'The web browser you’re currently using is no longer compatible with our enhanced security features. To avoid any issues, please use our application with a supported browser like Chrome or Edge.',
            'fr-CA': 'Le navigateur web que vous utilisez actuellement n’est plus compatible avec nos caractéristiques de sécurité améliorées. Pour éviter tout problème, veuillez utiliser notre application à l’aide d’un navigateur compatible, comme Chrome ou Edge.',
            'zh-Hans': '您当前使用的网络浏览器不再与我们增强的安全功能兼容。为避免出现任何问题，请使用支援的浏览器（如 Chrome 或 Edge）。',
            'zh-Hant': '您當前使用的網絡瀏覽器不再與我們增強的安全功能兼容。為避免出現任何問題，請使用支援的瀏覽器（如 Chrome 或 Edge）。',
        },
        getChrome: {
            'en-US': 'Get Chrome',
            'fr-CA': 'Obtenir Chrome',
            'zh-Hans': '下载Chrome',
            'zh-Hant': '下載Chrome',
        },
        getEdge: {
            'en-US': 'Get Edge',
            'fr-CA': 'Obtenir Edge',
            'zh-Hans': '下载Edge',
            'zh-Hant': '下載Edge',
        },
        backToLogin: {
            'en-US': 'Back to Login',
            'fr-CA': 'Retour connexion',
            'zh-Hans': '回到登入',
            'zh-Hant': '回到登入',
        },
    };

    return (
        <article className="ie-noSupport__wrapper">
            <section className="ie-noSupport__content">
                <div className="ie-noSupport-box">
                    <img className="ie-noSupport-img" src={InternetExplorerIcon} alt="" />
                </div>
                <h1 className="ie-noSupport-heading">{IE11Trans.title[lang] || IE11Trans.title['en-US']}</h1>
                <p className="ie-noSupport-desc">{IE11Trans.description[lang] || IE11Trans.description['en-US']}</p>
                <div className="ie-noSupport-buttons">
                    <Button
                        extraClass="ie-blue"
                        action={() =>  window.open('https://www.google.com/intl/en_in/chrome/') }
                    >
                        {IE11Trans.getChrome[lang] || IE11Trans.getChrome['en-US']}<img src={ChromeIcon} alt="" />
                    </Button>
                    <Button
                        extraClass="ie-blue"
                        action={() => window.open('https://www.microsoft.com/en-us/edge')}
                    >
                        {IE11Trans.getEdge[lang] || IE11Trans.getEdge['en-US']}<img src={MSEdgeIcon} alt="" />
                    </Button>
                </div>
            </section>
        </article>
    );
};


export default NoSupportIE11;